<template>
  <el-dialog
    width="40%"
    :title="!dataForm.taskId ? '任务新增' : '任务详情'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
      class="form"
    >
      <el-form-item label="任务名称" prop="skillName">
        <el-input v-model="dataForm.skillName"  maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="狗粮值" prop="energy">
        <el-input type="number" v-model="dataForm.energy"  min="0"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input v-model="dataForm.unit"></el-input>
      </el-form-item>
       <el-form-item label="所属团队" prop="teamId" v-if="showType">
        <el-select v-model="dataForm.teamId" placeholder="请选择" style="width:100%;" clearable>
          <el-option
            v-for="item in teamList"
            :key="item.teamId"
            :label="item.teamName"
            :value="item.teamId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">返回</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {skillSaveData} from '../api'
import { teamListData } from '@/api/list'
export default {
  props: {
    showType:{
      type: Boolean,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        skillId: '',
        teamId: "",
        teamName: "",
        skillName: "",
        energy: "",
        unit: "",
      },
      teamList:[],
      
      dataRule: {
        unit: [
          { required: true, message: '单位不能为空', trigger: 'blur' }
        ],
        skillName: [
          { required: true, message: '模板名称不能为空', trigger: 'blur' }
        ],
        energy: [
          { required: true, message: '狗粮不能为空', trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    init(id) {
      this.getRoleList()
      this.dataForm.skillId = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.taskId) {
         taskInfoData(this.dataForm.taskId).then(data => {
            if (data && data.code === 0) {
              this.dataForm.skillName = data.sysSkill.skillName;
              this.dataForm.unit = data.sysSkill.unit;
              this.dataForm.energy = data.sysSkill.energy;
            } else {
              this.$message.error(data.msg);
            }
          });
        }else{
          this.dataForm = {}
        }
      });
    },
     // 获取团队列表
    getRoleList() {
      teamListData({
          page: 1,
          limit: 10000,
      }).then( data  => {
        if (data && data.code === 0) {
          this.teamList = data.page.list;
        } else {
          this.teamList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let psotData = {
              skillId: this.dataForm.skillId || undefined,
              skillName: this.dataForm.skillName,
              energy:  Number(this.dataForm.energy),
              teamName: this.dataForm.teamName,
              teamId:  this.dataForm.teamId ||  sessionStorage.getItem('teamId'),
              unit: this.dataForm.unit
          };
           if(!this.dataForm.teamId && this.showType) {
              this.$message({
                message:'请选择团队',
                type:'warning'

              })
              return
            }
         skillSaveData(psotData).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .form{
    ::v-deep .el-input.is-disabled .el-input__inner{
      color: #000 !important;
    }
  }
</style>